// CMS chạy CHUNG origin với site tamdagroup (dev/tamdagroup.eu), nên chỉ site
// tamdamedia (domain khác) mới cần origin riêng — cấu hình qua env theo deployment.
const MEDIA_SITE_ID = "tamdamedia.eu"
const MEDIA_ORIGIN = process.env.NEXT_PUBLIC_SITE_ORIGIN_TAMDAMEDIA

/**
 * Public origin để xem trước nội dung từ admin. Content thuộc site tamdamedia →
 * mở trên origin tamdamedia (khác origin CMS). Mọi trường hợp còn lại (tamdagroup,
 * local, env chưa set) → same-origin, vốn chính là origin CMS/tamdagroup.
 */
export function getPreviewOrigin(contentDomain?: string): string {
  if (typeof window === "undefined") return ""
  const siteId = contentDomain?.trim().toLowerCase().replace(/^www\./, "")
  if (siteId === MEDIA_SITE_ID && MEDIA_ORIGIN) return MEDIA_ORIGIN.replace(/\/$/, "")
  return window.location.origin
}

/** URL công khai (bản đã publish) của một path trên đúng origin của site. */
export function getPreviewUrl(contentDomain: string | undefined, path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  return `${getPreviewOrigin(contentDomain)}${normalizedPath}`
}

/**
 * URL bật Draft Mode cho một lần xem trước, TRÊN ĐÚNG public origin của site.
 * Mint token preview ngắn hạn ở `/api/preview-token` (verify JWT admin, same-origin
 * với admin) rồi trỏ cửa sổ preview sang `<publicOrigin>/api/draft/enable?token=...`.
 * Cùng một build phục vụ mọi host nên `PREVIEW_SECRET` dùng chung — enable route
 * bên public origin verify được token do admin ký.
 */
export async function getDraftPreviewUrl(contentDomain: string | undefined, path: string): Promise<string> {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  const jwt = typeof window !== "undefined" ? localStorage.getItem("auth_token") : null
  if (!jwt) throw new Error("Missing admin token")

  const response = await fetch("/api/preview-token", {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${jwt}` },
    body: JSON.stringify({ path: normalizedPath }),
    cache: "no-store",
  })
  if (!response.ok) throw new Error("Unable to create preview token")
  const { token } = (await response.json()) as { token?: string }
  if (!token) throw new Error("Preview token is missing")

  const origin = getPreviewOrigin(contentDomain) || (typeof window !== "undefined" ? window.location.origin : "")
  return `${origin}/api/draft/enable?token=${encodeURIComponent(token)}`
}
